import getApplicationSettings from 'owa-application-settings/lib/selectors/getApplicationSettings';
import getIsCurrentThemeModern from './getIsCurrentThemeModern';
import getIsCurrentThemeFullBleed from './getIsCurrentThemeFullBleed';

export default function getIsMicaEffectEnabled(): boolean {
    if (getApplicationSettings('PlatformType').isMonarch) {
        return getIsCurrentThemeModern() || getIsCurrentThemeFullBleed(); // theme check
    } else {
        return getIsCurrentThemeFullBleed();
    }
}
